export const AI_CHATBOT_SEND_MESSAGE = 'AI_CHATBOT_SEND_MESSAGE';
export const AI_CHATBOT_RECEIVE_MESSAGE = 'AI_CHATBOT_RECEIVE_MESSAGE';
export const AI_CHATBOT_SET_LOADING = 'AI_CHATBOT_SET_LOADING';
export const AI_CHATBOT_SET_TOKENS = 'AI_CHATBOT_SET_TOKENS';
export const AI_CHATBOT_SET_ERROR = 'AI_CHATBOT_SET_ERROR';
export const AI_CHATBOT_RESET = 'AI_CHATBOT_RESET';
export const AI_CHATBOT_SET_OPEN = 'AI_CHATBOT_SET_OPEN';
export const AI_CHATBOT_SET_HEADER_CHIP_VISIBILITY = 'AI_CHATBOT_SET_HEADER_CHIP_VISIBILITY';

export interface ChatMessageType {
  text: string;
  sender: 'user' | 'bot';
  errorType?: 'api' | 'token';
  cache_key?: string | null;
}

export interface AiChatBotState {
  messages: ChatMessageType[];
  loading: boolean;
  tokens: {
    total_tokens: number;
    unused_tokens: number;
  };
  open: boolean;
  isHeaderChipVisible: boolean;
  consecutiveApiErrors: number;
}

const initialState: AiChatBotState = {
  messages: [
    {
      text: '👋 Hello! Ask me anything about your data, and I’ll find the answer in the dashboard.',
      sender: 'bot',
      cache_key: null
    }
  ],
  loading: false,
  tokens: {
    total_tokens: 0,
    unused_tokens: 0
  },
  open: false,
  isHeaderChipVisible: true,
  consecutiveApiErrors: 0
};
export const AI_CHATBOT_INCREMENT_API_ERROR = 'AI_CHATBOT_INCREMENT_API_ERROR';
export const AI_CHATBOT_RESET_API_ERROR = 'AI_CHATBOT_RESET_API_ERROR';

export default function aiChatBotReducer(state = initialState, action: any): AiChatBotState {
  switch (action.type) {
    case AI_CHATBOT_INCREMENT_API_ERROR:
      return {
        ...state,
        consecutiveApiErrors: state.consecutiveApiErrors + 1
      };
    case AI_CHATBOT_RESET_API_ERROR:
      return {
        ...state,
        consecutiveApiErrors: 0
      };
    case AI_CHATBOT_SEND_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.payload]
      };
    case AI_CHATBOT_RECEIVE_MESSAGE:
      return {
        ...state,
        messages: Array.isArray(action.payload) ? [...action.payload] : [...state.messages]
      };
    case AI_CHATBOT_SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case AI_CHATBOT_SET_TOKENS:
      return {
        ...state,
        tokens: {
          ...state.tokens,
          ...(action.payload && typeof action.payload === 'object' ? action.payload : {})
        }
      };
    case AI_CHATBOT_SET_ERROR:
      return {
        ...state,
        messages: action.payload ? [...state.messages, action.payload] : [...state.messages]
      };
    case AI_CHATBOT_SET_OPEN:
      return {
        ...state,
        open: action.payload
      };
    case AI_CHATBOT_SET_HEADER_CHIP_VISIBILITY:
      return {
        ...state,
        isHeaderChipVisible: action.payload
      };
    case AI_CHATBOT_RESET:
      return initialState;
    default:
      return state;
  }
}
